import { useId } from "react";
import { cn } from "@/lib/utils";
import { SITE } from "@/lib/site";

interface LogoMarkProps {
  className?: string;
  size?: number;
  /** @deprecated Legacy del mark vectorial — se acepta para no romper llamadas. */
  inverted?: boolean;
  /** @deprecated Legacy del mark vectorial — se acepta para no romper llamadas. */
  accent?: boolean;
  /** @deprecated Legacy del mark vectorial — se acepta para no romper llamadas. */
  bgColor?: string;
  /** @deprecated Legacy del mark vectorial — se acepta para no romper llamadas. */
  fgColor?: string;
}

/**
 * Vortixy mark — icono aprobado 2026-09-15 (vórtice blanco→rosa sobre charcoal,
 * `public/icon-192x192.png` generado del master en Downloads vía
 * `scripts/gen-icons-from-master.cjs`).
 *
 * Adaptación dark/light SIN tocar el original (decisión dueño 2026-09-15): el
 * raster es idéntico en ambos temas — solo cambia el marco CSS. En light el
 * tile oscuro flota sobre papel con hairline + sombra (se lee como pastilla
 * intencional); en dark se funde con hairline clara sutil. Cuando exista un
 * master light real, este componente elegirá por tema aquí.
 */
export function LogoMark({ className, size = 32 }: LogoMarkProps) {
  const clipId = useId().replace(/[^a-zA-Z0-9]/g, "");
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(
        // 2026-09-20 FASE 3 P2: hairline por token (resuelve por tema, sin duplicar dark:).
        // 2026-09-23 FASE 3 FIX diseño H5 (research 2026 single-source radius:
        // rounded-[25%] ≈ 8px → var(--radius-sm) 10px escala SSOT, mismo lenguaje).
        "shrink-0 rounded-[var(--radius-sm)] shadow-sm ring-1 ring-[var(--border)]",
        className,
      )}
      aria-hidden="true"
    >
      <defs>
        <clipPath id={`vtx-${clipId}`}>
          <rect width="32" height="32" rx="8" />
        </clipPath>
      </defs>
      {/* SSOT SITE.iconVersion — cache-busting (headers immutable 1 año). */}
      <image
        href={`/icon-192x192.png?v=${SITE.iconVersion}`}
        width="32"
        height="32"
        preserveAspectRatio="xMidYMid slice"
        clipPath={`url(#vtx-${clipId})`}
      />
    </svg>
  );
}
